import { memo } from 'react'

const BidStatusLabel = ({ active, labelActive, labelInactive }) => {
    return (
        <div className="auction-info-item" id="bid-modal-toggle">
            <i className={`ri-cursor-line ${!active ? 'text-danger' : ''}`} />
            <span className={!active ? 'text-danger' : ''}>{!active ? labelInactive : labelActive}</span>
        </div>
    )
}

export default memo(BidStatusLabel)
